import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { ProviderService } from '../services/provider.service';

@Injectable({ providedIn: 'root' })
export class HbcGoRedirectGuard implements CanActivate {
  constructor(
    private providerService: ProviderService,
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const tenantId = route.params.tenantId;

    return combineLatest([this.providerService.isHbcGoUser$, this.authService.superAdmin$]).pipe(
      take(1),
      map(([isHbcGoUser, superAdmin]) => {
        // Super admins can navigate freely — redirecting them here caused an infinite loop
        // because /:tenantId/provider itself also carries this guard.
        if (superAdmin) {
          return true;
        }

        if (isHbcGoUser) {
          return this.router.parseUrl(`/${tenantId}/hbc-go`);
        }
        return true;
      })
    );
  }
}
